import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "cards-wr" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "button-wrapper" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "title-main" }, "Subscriptions & Billing", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Review and manage your subscriptions, add-ons, invoices and payment methods.", -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "button default primary v2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.getChargebeePortalSession())),
              disabled: $setup.loading || !$setup.chargebeeCustomerId
            }, "Manage", 8, _hoisted_6)
          ])), [
            [_directive_tippy, { content: !$setup.chargebeeCustomerId ? $setup.tooltipText : '', theme: 'light-border', placement: 'bottom' }]
          ])
        ])
      ])
    ])
  ]))
}